import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-gray-900 dark:bg-gray-950 text-white mt-12 py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center">
          <img 
            src="https://www.2kbundesliga.de/wp-content/uploads/2022/01/cropped-cropped-2kbuli-header_06.png" 
            alt="2K Bundesliga Logo"
            className="h-16 w-auto object-contain mb-4"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
          <p className="text-lg mb-2 text-center">{t('footer.description')}</p>
          <p className="text-gray-400 text-sm text-center">
            {t('footer.platforms')}
          </p>
          <p className="text-gray-500 dark:text-gray-400 text-xs mt-4">
            © {new Date().getFullYear()} 2K Bundesliga. {t('footer.rights')}.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
